import css from './Details.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { IGoodServiceTicketData } from 'meta/pages/goodsandservices'
import { Dates } from 'utils/dates'

import { ButtonWhiteBlack } from 'components/Actions/Action'

interface Props {
  data: IGoodServiceTicketData
}

const Details: React.FC<Props> = (props) => {
  const { data } = props

  const { t } = useTranslation()

  return (
    <div className={css.wrapper}>
      <div className={css.voices}>
        {data.locationName && (
          <div className={css.voice}>{`${t('goodsAndServices:details_location_name')}: ${data.locationName}`}</div>
        )}

        {data.status && (
          <div className={css.voice}>
            {`${t('goodsAndServices:details_status')}: ${t(`goodsAndServices:status_${data.status}`)}`}
          </div>
        )}

        {data.emissionDate_tz && (
          <div className={css.voice}>
            {`${t('goodsAndServices:details_purchase_data')}: ${Dates.format(new Date(data.emissionDate_tz), t('goodsAndServices:status_checked_datetime'))}`}
          </div>
        )}

        {data.validFrom && (
          <div className={css.voice}>
            {`${t('goodsAndServices:details_usable_from')}: ${Dates.format(new Date(data.validFrom), t('goodsAndServices:details_usable_from_datetime'))}`}
          </div>
        )}

        {data.price && (
          <div className={css.voice}>{`${t('goodsAndServices:details_price')}: ${data.price.formatted}`}</div>
        )}
      </div>

      {data.receiptsUri && (
        <div className={css.showReceipt}>
          <ButtonWhiteBlack
            className={css.receiptButton}
            onClick={() => {
              window.open(data.receiptsUri, '_blank')
            }}
          >
            <h5>{t('wallet:show_receipt')}</h5>
          </ButtonWhiteBlack>
        </div>
      )}
    </div>
  )
}

export default Details
